// کسورات صورت وضعیت (tblContractorRequestDeduction) — مودال از داخل صورت وضعیت قراردادها
import React, { useState, useEffect, useCallback } from 'react';
import { ui } from '../../components/ListPage';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa   = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const fmtNum = n => (n ? Number(n).toLocaleString('fa-IR') : '•');

const API = (path, opts = {}) => fetch(`/api/contract${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

const EMPTY = { deduction_id: 0, deduction_title: '', deduction: '', deduction_percent: '', bill_id: '', slip_id: '' };

function Lookup({ label, value, endpoint, onPick }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => { setQ(text); const j = await API(`${endpoint}?q=${encodeURIComponent(text)}`); if (j.ok) { setRows(j.rows); setOpen(true); } };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 2, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => search(q)} onChange={e => search(e.target.value)} placeholder="جستجو..." style={ui.input} />
      {value && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 1300, maxHeight: '220px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>{r.display}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function ContractorRequestDeductions({ reqId, title, sumAmount, onClose, onChanged }) {
  // دکمه‌های فرم FRMCONTRACTORREQUESTDEDUCTION — هر دکمه فقط با مجوز خودش دیده می‌شود
  const vbf = useFormButtons('FRMCONTRACTORREQUESTDEDUCTION', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK"]);
  const [data, setData]         = useState([]);
  const [sumDed, setSumDed]     = useState(0);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState(EMPTY);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [toast, setToast]       = useState('');

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 2500); };

  const load = useCallback(async () => {
    setLoading(true); setError(''); setSelected(null);
    const j = await API(`/contractor-requests/${reqId}/deductions/`);
    setLoading(false);
    if (j.ok) { setData(j.data); setSumDed(j.sum_deduction || 0); } else setError(j.msg);
  }, [reqId]);

  useEffect(() => { load(); }, [load]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew  = () => { if (!vbf.can('BTNNEW')) return; setForm(EMPTY); setError(''); setModal('new'); };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return; if (!selected) return; setForm({ ...EMPTY, ...selected }); setError(''); setModal('edit'); };
  const openDel  = () => { if (!vbf.can('BTNDELETE')) return; if (selected) setModal('delete'); };

  // درصد → مبلغ (بر پایه جمع صورت وضعیت)
  const applyPercent = (pct) => {
    F('deduction_percent', pct);
    const p = parseFloat(pct);
    if (!isNaN(p) && p > 0 && sumAmount) F('deduction', Math.round(sumAmount * p / 100));
  };

  const save = async () => {
    setSaving(true); setError('');
    const j = modal === 'new'
      ? await API(`/contractor-requests/${reqId}/deductions/create/`, { method: 'POST', body: JSON.stringify(form) })
      : await API(`/contractor-requests/${reqId}/deductions/${selected.id}/update/`, { method: 'PUT', body: JSON.stringify(form) });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(); onChanged && onChanged(); }
    else setError(j.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/contractor-requests/${reqId}/deductions/${selected.id}/delete/`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('حذف شد'); load(); onChanged && onChanged(); }
    else { setError(j.msg); setModal(null); }
  };

  return (
    <div style={ui.overlay} onClick={onClose}>
      <div style={{ ...ui.modal, maxWidth: '900px', width: '96%', height: '82vh' }} onClick={e => e.stopPropagation()}>
        <div style={ui.mHeader}>
          <div style={ui.mTitle}>کسورات صورت وضعیت — {title}</div>
          <button onClick={onClose} style={ui.closeBtn}>✕</button>
        </div>

        <div style={{ display: 'flex', gap: '8px', padding: '12px 18px', borderBottom: '1px solid #f0f2f7', flexWrap: 'wrap', alignItems: 'center' }}>
          {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
          {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش</button>}
          {vbf.can('BTNDELETE') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
          {loading && <span>⏳</span>}
          <div style={{ marginRight: 'auto', display: 'flex', gap: '10px', fontSize: '12px', fontWeight: '700' }}>
            <span style={{ color: '#1a237e' }}>جمع صورت وضعیت: {fmtNum(sumAmount)}</span>
            <span style={{ color: '#b71c1c' }}>جمع کسورات: {fmtNum(sumDed)}</span>
            <span style={{ color: '#1b5e20' }}>خالص: {fmtNum((sumAmount || 0) - sumDed)}</span>
          </div>
        </div>

        {error && !modal && <div style={{ ...ui.errBox, margin: '10px 18px' }}>⚠️ {error}</div>}

        <div style={{ flex: 1, overflowY: 'auto', margin: '0 18px 12px', borderRadius: '10px', border: '1px solid #eee' }}>
          <table style={{ ...ui.table, tableLayout: 'auto' }}>
            <thead style={{ position: 'sticky', top: 0, zIndex: 5 }}>
              <tr>{['عنوان کسور', 'گیرنده', 'درصد', 'مبلغ', 'شناسه قبض', 'شناسه پرداخت'].map((h, i) => <th key={i} style={ui.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {data.map((r, i) => {
                const sel = selected?.id === r.id;
                const bg  = sel ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf6e3';
                const tc  = sel ? '#fff' : '#111';
                return (
                  <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                    onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                    onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                    onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.deduction_title || '•'}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.receiver || '•'}</td>
                    <td style={{ ...ui.td, color: tc }}>{r.deduction_percent ? toFa(r.deduction_percent) + '٪' : '•'}</td>
                    <td style={{ ...ui.tdNum, color: sel ? '#fff' : '#b71c1c' }}>{fmtNum(r.deduction)}</td>
                    <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: tc }}>{r.bill_id || '•'}</td>
                    <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: tc }}>{r.slip_id || '•'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!loading && data.length === 0 && <div style={ui.empty}>📭 کسوری ثبت نشده است</div>}
        </div>
      </div>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '620px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ کسور جدید' : '✎ ویرایش کسور'}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}
              <div style={ui.row}>
                <Lookup label="نوع کسور" value={form.deduction_title} endpoint="/contractor-requests/lookup/deduction/"
                  onPick={r => setForm(f => ({ ...f, deduction_id: r.id, deduction_title: r.display }))} />
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '130px' }}>
                  <label style={ui.mlabel}>درصد</label>
                  <input type="number" step="0.01" value={form.deduction_percent} onChange={e => applyPercent(e.target.value)} style={ui.input} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>مبلغ کسور (ریال)</label>
                  <input type="number" value={form.deduction} onChange={e => F('deduction', e.target.value)} style={ui.input} />
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>شناسه قبض</label>
                  <input value={form.bill_id} onChange={e => F('bill_id', e.target.value)} style={ui.input} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>شناسه پرداخت</label>
                  <input value={form.slip_id} onChange={e => F('slip_id', e.target.value)} style={ui.input} />
                </div>
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '420px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '24px' }}>
              <div style={{ fontSize: '30px', marginBottom: '8px' }}>🗑️</div>
              {selected?.deduction_title}<br />{fmtNum(selected?.deduction)} ریال
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </div>
  );
}
